/**
 * Кастомный календарь
 */
$.fn.customDatepickerRange = function(minDate, maxDate, lang) {
    if (typeof $.fn.datepicker !== 'undefined') {
        const ORIGINAL_FROM_DATE = {
            year: null,
            month: null,
            day: null,
            date: null
        };

        const ORIGINAL_TO_DATE = {
            year: parseInt(maxDate.getFullYear()),
            month: parseInt(maxDate.getMonth()),
            day: parseInt(maxDate.getDate()),
            date: maxDate,
        };

        const TypesCalendar = {
          FROM: `FROM`,
          TO: `TO`
        };

        const NamesInput = {
          FROM: 'dateFrom',
          TO: 'dateTo'
        };

        let $self = $(this);
        const $loader = $('.js-loader-wrapper');
        const ajaxUrl = $self.data('ajaxUrl');

        const $calendarFrom = $self.find(`.js-calendar[data-type="${TypesCalendar.FROM}"]`);
        const $calendarTo = $self.find(`.js-calendar[data-type="${TypesCalendar.TO}"]`);
        const $fieldFrom = $self.find(`input[name="${NamesInput.FROM}"]`);
        const $fieldTo = $self.find(`input[name="${NamesInput.TO}"]`);
        const $allCalendars = $self.find('.js-calendar');

        let fromDates = $.extend({}, ORIGINAL_FROM_DATE);
        let toDates = $.extend({}, ORIGINAL_TO_DATE);


        const defaultParams = {
            'AJAX': true,
            'SECTION_CODE': $self.data('sectionCode')
        };
        const $newsListWrap = $('.js-news-list-wrap');

        let tagId = null;

        /**
         * Получение GET-параметров из url
         * @returns {any}
         */
        const getUrlParams = function () {
            // извлекаем строку из объекта window
            var queryString = window.location.search.slice(1);

            // объект для хранения параметров
            var obj = {};
            // если есть строка запроса
            if (queryString) {
                // данные после знака # будут опущены
                queryString = queryString.split('#')[0];
                // разделяем параметры
                var arr = queryString.split('&');

                for (var i=0; i<arr.length; i++) {
                    // разделяем параметр на ключ => значение
                    var a = arr[i].split('=');
                    // обработка данных вида: list[]=thing1&list[]=thing2
                    var paramNum = undefined;
                    var paramName = a[0].replace(/\[\d*\]/, function(v) {
                        paramNum = v.slice(1,-1);
                        return '';
                    });
                    // передача значения параметра ('true' если значение не задано)
                    var paramValue = typeof(a[1])==='undefined' ? true : a[1];
                    // преобразование регистра
                    //paramName = paramName.toLowerCase();
                    //paramValue = paramValue.toLowerCase();
                    // если ключ параметра уже задан
                    if (obj[paramName]) {
                        // преобразуем текущее значение в массив
                        if (typeof obj[paramName] === 'string') {
                            obj[paramName] = [obj[paramName]];
                        }
                        if (typeof paramNum === 'undefined') {
                            obj[paramName].push(paramValue);
                        }
                        else {
                            obj[paramName][paramNum] = paramValue;
                        }
                    }
                    // если параметр не задан, делаем это вручную
                    else {
                        obj[paramName] = paramValue;
                    }
                }
            }

            return obj;
        };

        /**
         * Установка GET-параметров в url
         */
        const setUrlParams = function (paramsObject) {
            let paramsArray = [];
            for (let param in paramsObject) {
                paramsArray.push([param, paramsObject[param]]);
            }
            let pageUrl = window.location.href.split('?')[0];
            let paramsString = paramsArray.map(el => `${el[0]}=${el[1]}`).join('&');
            window.history.pushState({
                html: $newsListWrap.html(),
                pageTitle: document.title
            }, '', `${pageUrl}?${paramsString}`);
        };

        /**
         * Получение списка новостей
         * @param {Object} requestParams
         */
        const getNews = function (requestParams) {
            let params = $.extend({}, defaultParams, requestParams);
            $loader.addClass('loading');
            $newsListWrap.empty();
            $.ajax({
                url: ajaxUrl,
                data: params
            }).done(function (result) {
                $loader.removeClass('loading');
                setUrlParams(requestParams);
                $newsListWrap.html(result);
                $newsListWrap.find('.pagination a').each(function () {
                    let $link = $(this);
                    $link.attr('href', '?' + $link.attr('href').split('?')[1].replace('AJAX=true&', ''));
                });
            }).fail(function (err) {
                console.log('Не удалось загрузить список новостей', err);
            });
        };

        const getSelectedYear = function(holder) {
            const $select = $(holder).find('.js-select2.calendar-filter-year');

            return parseInt($select.val());
        };

        const getSelectedMonth = function(holder) {
            const $select = $(holder).find('.js-select2.calendar-filter-month');

            return parseInt($select.val()) + 1;
        };

        const changeDateToString = (date) => {
            if (date === null) {
                return '';
            }

          const year = date.getFullYear();
          let month = date.getMonth() + 1;
          const day = date.getDate().toString().padStart(2, '0');

          month = month.toString().padStart(2, '0');

          return `${day}.${month}.${year}`;
        };

        const getDateObject = (dateString) => {
          const IndexMap = {
              day: 0,
              month: 1,
              year: 2,
          };

          const parametrs = dateString.split('.');
          const year = parseInt(parametrs[IndexMap.year]);
          const month = parseInt(parametrs[IndexMap.month]) - 1;
          const day = parseInt(parametrs[IndexMap.day]);

          return {
              year,
              month,
              day,
              date: new Date(year, month, day),
          }
        };

        const createParamsRequest = () => {
            const params = {};

            if (fromDates.date !== null) {
                params[NamesInput.FROM] = changeDateToString(fromDates.date);
            }

            if (toDates.date !== null) {
                params[NamesInput.TO] = changeDateToString(toDates.date);
            }

            if (tagId) {
                params['TAG'] = tagId;
            }

            return params;
        };

        /***
         * Установить ошибку
         */

        const setError = (calendar) => {
            $(calendar).each(function () {
                $(this).closest('.js-calendar-range-field').addClass('has-error');
            });
        };

        /**
         * Сбрасываем ошибку
         */
        const clearError = (calendar = $allCalendars) => {
            $(calendar).each(function () {
               $(this).closest('.js-calendar-range-field').removeClass('has-error');
            });
        };

        /***
         * Обновляем дейтпикер
         * @param {string} type
         * @param {object}  date
         */
        const updateDatePicker = (type, date) => {

            const dateNew = getDateObject(date);
            const $calendar = (type === TypesCalendar.TO) ? $calendarTo : $calendarFrom;
            const datePicker = $calendar.data('datepicker');
            const $yearSelect = $calendar.find('.js-select2.calendar-filter-year');
            const $monthSelect = $calendar.find('.js-select2.calendar-filter-month');

            if ($yearSelect.find('[value="' + dateNew.year + '"]').length) {
                $yearSelect.val(dateNew.year).trigger('change.select2');
            }

            if (dateNew.month + 1 && $monthSelect.find('[value="' + dateNew.month + '"]').length) {
                $monthSelect.val(dateNew.month).trigger('change.select2');
            }

            if (dateNew.year && dateNew.month + 1
                && datePicker !== 'undefined') {
                datePicker.date = dateNew.date;
            }

            if (type === TypesCalendar.FROM) {
                fromDates = $.extend({}, fromDates, dateNew);
            }

            if (type === TypesCalendar.TO) {
                toDates = $.extend({}, toDates, dateNew);
            }

        };


        /***
         * Выбор даты в дейтпикере
         * @param type
         * @param date
         */
        const handlerChangeDate = function (type, date) {

            const selectedDate = {
              year: parseInt(date.getFullYear()),
              month: parseInt(date.getMonth()),
              day: parseInt(date.getDate()),
              date: date,
            };

            const text = changeDateToString(date);

            clearError();

            // Смотрим что бы выбранная дата был не больше второго поля
            if (type === TypesCalendar.FROM) {
                if (toDates !== null
                    && selectedDate.date.getTime() > toDates.date.getTime() || selectedDate.day > toDates.day) {
                    setError($calendarFrom);
                    return;
                }

                // Обновляем данные и подставляем текст в input
                fromDates = $.extend({}, fromDates, selectedDate);
                $fieldFrom.val(text);
            }

            // Смотрим что бы выбранная дата был не меньше первого поля
            if (type === TypesCalendar.TO) {
                if (fromDates.date !== null
                    && selectedDate.date.getTime() < fromDates.date.getTime() || selectedDate.day < fromDates.day) {
                    setError($calendarTo);
                    return;
                }

                // Обновляем данные и подставляем текст в input
                toDates = $.extend({}, toDates, selectedDate);
                $fieldTo.val(text);
            }

            // Показываем новости после выбора даты
            getNews(createParamsRequest());
        };

        const goToDefaultCalendar = function () {

            const allYearSelect = $self.find('.js-select2.calendar-filter-year');
            const allMonthSelect = $self.find('.js-select2.calendar-filter-month');
            const toDatePicker = $calendarTo.data('datepicker');
            const fromDatePicker = $calendarFrom.data('datepicker');

            //Очищаем ошибки
            clearError();

            // Обновляем селекты
            allYearSelect.val(maxDate.getFullYear()).trigger('change.select2');
            allMonthSelect.val(maxDate.getMonth()).trigger('change.select2');

            //Устанавливаем в датапикеры стандартную дату
            toDatePicker.date = maxDate;
            fromDatePicker.date = maxDate;

            //Обнуляем выбранные дни в датапикере
            toDatePicker.selectedDates = [];
            fromDatePicker.selectedDates = [];

            // Сбрасываем данные
            toDates = $.extend({}, toDates, ORIGINAL_TO_DATE);
            fromDates = $.extend({}, fromDates, ORIGINAL_FROM_DATE);

            // Сбрасываем поля ввода
            $fieldFrom.val(changeDateToString(fromDates.date));
            $fieldTo.val(changeDateToString(toDates.date));

            // Показываем все новости
            getNews(createParamsRequest());
        };

        const initDatePicker = function (holder) {
            const $calendar = $(holder);

            // Если подключен select2 - добавляем выбор месяца/года
            if (typeof $.fn.select2 !== 'undefined') {
                $calendar.prepend($('<div>', {
                    class: 'calendar-filter js-calendar-filter',
                    append: [
                        $('<select>', {
                            class: 'js-select2 calendar-filter-month',
                            attr: {
                                'data-select2-class': 'select2-filter-month'
                            },
                            append: function () {
                                let monthArray;
                                monthArray = [
                                    'Январь',
                                    'Февраль',
                                    'Март',
                                    'Апрель',
                                    'Май',
                                    'Июнь',
                                    'Июль',
                                    'Август',
                                    'Сентябрь',
                                    'Октябрь',
                                    'Ноябрь',
                                    'Декабрь'
                                ];
                                if (lang === 'en') {
                                    monthArray = [
                                        'January',
                                        'February',
                                        'March',
                                        'April',
                                        'May',
                                        'June',
                                        'July',
                                        'August',
                                        'September',
                                        'October',
                                        'November',
                                        'December'
                                    ];
                                }

                                return monthArray.map(function (el, index) {
                                    return $('<option>', {
                                        value: index,
                                        text: el,
                                        selected: index === maxDate.getMonth()
                                    });
                                });
                            }
                        }),
                        $('<select>', {
                            class: 'js-select2 calendar-filter-year',
                            attr: {
                                'data-select2-class': 'select2-filter-year'
                            },
                            append: function () {
                                let minYear = minDate.getFullYear();
                                let maxYear = maxDate.getFullYear();
                                let optionsArray = [];

                                for (let i = minYear; i <= maxYear; i++) {
                                    optionsArray.push($('<option>', {
                                        value: i,
                                        text: i,
                                        selected: i === maxDate.getFullYear()
                                    }));
                                }

                                return optionsArray;
                            }
                        }),
                    ]
                }));

                /**
                 * Инициализация select2 для полей выбора года/месяца
                 */
                const $calendarSelect = $calendar.find('.js-calendar-filter .js-select2');

                $calendarSelect.each(function () {
                    let $select = $(this);
                    $select.select2({
                        width: 'style',
                        dropdownParent: $select.parent(),
                        containerCssClass: $select.data('select2-class')
                    });

                    $select.on('change', function () {
                        const $target = $(this);
                        const $currentCalendar = $target.closest('.js-calendar');
                        let datepicker = $currentCalendar.data('datepicker');
                        let selectedYear = getSelectedYear($currentCalendar);
                        let selectedMonth = getSelectedMonth($currentCalendar).toString().padStart(2, '0');

                        if (typeof datepicker !== 'undefined') {
                            datepicker.date = new Date(`${selectedYear}-${selectedMonth}-01`);
                        }
                    });

                    // Если подключен PerfectScrollbar - подключаем кастомный скролл в выпадающих списках
                    if (typeof PerfectScrollbar !== 'undefined') {
                        $select.on('select2:open', function () {
                            $('.select2-results__options').each(function (index, el) {
                                if (typeof $(el).data('ps') === 'undefined') {
                                    $(el).data('ps', new PerfectScrollbar(el, {
                                        suppressScrollX: true
                                    }));
                                }
                                setTimeout(function () {
                                    $(el).data('ps').update();
                                }, 100);
                            });
                        });
                    }
                });

                // Страница не должна скроллиться, пока скроллится список опций
                $(document).on('wheel', '.select2-results__options', function (e) {
                    e.preventDefault();
                });
            }

            // Инициализация датапикера
            $calendar.datepicker({
                inline: true,
                minDate: minDate,
                maxDate: maxDate, // нельзя читать новости из будущего - у одних ребят была куча проблем из-за этого в 1985 году
                startDate: maxDate,
                toggleSelected: false,
                selectOtherMonths: false,
                onSelect: function (formattedDate, date) { // обработка выбора конкретной даты в календаре
                    handlerChangeDate($calendar.data('type'), date);
                }
            });
        };


        /**
         * Инициализация
         */
        const init = function () {

            $self.find('.js-calendar').each(function () {
               initDatePicker($(this));
            });


            /**
             * Заполнение данных из урла
             */
             if (Object.keys(getUrlParams()).length) {
                 const data = getUrlParams();

                 if (typeof data['dateTo'] !== 'undefined') {
                     updateDatePicker(TypesCalendar.TO, data.dateTo);
                 }

                 if (typeof data['dateFrom'] !== 'undefined') {
                     updateDatePicker(TypesCalendar.FROM, data.dateFrom);
                 }
             }

            /**
             * Выбор тэга
             */
            $(document).on('click', '.js-tag-link', function (e) {
                e.preventDefault();

                const activeClass = 'active';

                if ($(this).hasClass(activeClass)) {
                    tagId = null;
                } else {
                    tagId = $(this).data('tagid');
                }

                const $links = $('.js-tag-link');

                $links.removeClass(activeClass);

                if (tagId) {
                    $links.filter('[data-tagid="' + tagId + '"]').addClass(activeClass);
                }

                let params = createParamsRequest();

                getNews(params);
            });

            /**
             * пагинация
             */
            $newsListWrap.on('click', '.pagination a', function() {
                const href = $(this).attr('href');
                let pageData = href.match(/PAGEN_(\d+)\=(\d+)/);

                let pager = 1;
                let page = 1;
                if (pageData && typeof pageData[1] !== 'undefined' && typeof pageData[2] !== 'undefined') {
                    pager = pageData[1];
                    page = pageData[2];
                }

                const pagerParam = 'PAGEN_' + pager;

                let params = createParamsRequest();

                params[pagerParam] = page;

                getNews(params);

                scroll(0, 0);

                return false;
            });

            $self.on('click', '.js-clear-calendar', function () {
                goToDefaultCalendar();
            });
        };

        init();
    }
};
